import { Imatge } from '@portal-internet/components';
import { getStorageValue, setStorageValue } from '@portal-internet/core';
import Boto from 'components/ui/Boto';
import { useModulAvis } from 'hooks/useModulAvis';
import { useProducte } from 'hooks/3cat/useProducte';
import { useUser } from 'hooks/useUser';
import __isUndefined from 'lodash/isUndefined';
import { useRouter } from 'next/router';
import { useEffect, useRef, useState } from 'react';
import styles from './onboardinglogin.module.scss';

export default function Component(props) {
    const [showOnboarding, setShowOnboarding] = useState(false);
    const [showedToday, setShowedToday] = useState(true);
    const [cookieChecked, setCookieChecked] = useState(false);
    const timeoutShowOnboarding = useRef();
    const { isWebviewActive } = useProducte();
    const { isModulAvisActive } = useModulAvis();

    const router = useRouter();
    const refOnboarding = useRef();
    const isTest = typeof window !== 'undefined' && window.Cypress;
    const { signUp, signIn, loginState, loginStateTypes } = useUser();
    const nomCookie = 'onboarding';
    const estructuraCookieDefault = {
        day: '2020/01/01'
    };

    const isEmbedOrPopup = router.asPath.includes('/popup/') || router.asPath.includes('/embed/');

    const saveOnStorage = (values) => {
        setStorageValue(nomCookie, values, {
            path: '/',
            domain: '.3cat.cat',
            expires: 1
        });
    };
    const initializeValues = (data) => {
        let response;
        if (__isUndefined(data)) {
            response = estructuraCookieDefault;
        } else {
            response = data;
        }
        return response;
    };

    const fetchDayCookieData = async () => {
        const data = await getStorageValue(nomCookie);
        let value = initializeValues(data);
        let todayDate = getToday();
        if (value.day !== todayDate) {
            value.day = todayDate;
            setShowedToday(false);
            saveOnStorage(value);
        }
        setCookieChecked(true);
    };

    const tancaOnboarding = () => {
        netejeUrlOnboarding();
        setShowOnboarding(false);
        setShowedToday(true);
        document.getElementById('__mainContent').removeAttribute('inert');
    };

    const netejeUrlOnboarding = () => {
        let url = router.asPath?.split('#')[0];
        router.push(url, undefined, { scroll: false });
    };

    const getToday = () => {
        const dateObj = new Date();
        const month = dateObj.getUTCMonth() + 1;
        const day = dateObj.getUTCDate();
        const year = dateObj.getUTCFullYear();
        return year + '/' + month + '/' + day;
    };

    useEffect(() => {
        fetchDayCookieData();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        if (!__isUndefined(refOnboarding.current) && showOnboarding === true && !isTest && !showedToday) {
            refOnboarding.current.focus();
            document.getElementById('__mainContent').setAttribute('inert', true);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [refOnboarding.current]);

    useEffect(() => {
        if (loginState === loginStateTypes.GUEST && !isWebviewActive && cookieChecked) {
            timeoutShowOnboarding.current = setTimeout(() => {
                setShowOnboarding(true);
            }, 3500);
        }
        return () => clearTimeout(timeoutShowOnboarding.current);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [loginState, cookieChecked]);

    const contentOnBoarding = () => {
        return (
            <div
                className={styles.onBoardingLogin}
                {...{
                    'role': 'dialog',
                    'aria-modal': 'true',
                    'aria-labelledby': 'onboarding-titol'
                }}
            >
                <div className={styles.mask + ' ' + styles.onboarding} onClick={() => tancaOnboarding()} ref={refOnboarding}>
                    <div className={styles.wrapper} onClick={(e) => e.stopPropagation()}>
                        <div className={styles.img}>
                            <div className={styles.imgTop}>
                                <Imatge
                                    src={'https://img.3cat.cat/multimedia/png/1/2/1762426510821.png'}
                                    layout='fill'
                                    objectFit='cover'
                                    alt=''
                                />
                            </div>
                            <div className={styles.imgBottom}>
                                <Imatge
                                    src={'https://img.3cat.cat/multimedia/png/8/8/1762426597188.png'}
                                    layout='fill'
                                    objectFit='cover'
                                    alt=''
                                />
                            </div>
                        </div>
                        <div className={styles.text}>
                            <h1 className={styles.title} id='onboarding-titol'>
                                Crea <span>la teva llista</span>
                                <br />i desa les teves sèries
                                <br />i programes favorits
                            </h1>
                            <p className={styles.subtitle}>
                                Amb el teu compte 3Cat pots guardar <strong>la teva llista</strong> de preferits en tots els
                                dispositius.
                            </p>
                            <div className={styles.btns}>
                                <Boto
                                    tag='button'
                                    text='Inicia sessió'
                                    estil='enllac'
                                    onClick={() => signUp()}
                                    className={`${styles.btn_inicia} ${styles.link}`}
                                    dataTestId='onboarding-inicia-sessio-button'
                                />
                                <Boto
                                    onClick={() => signIn()}
                                    tag='button'
                                    className={`${styles.btn_crea} ${styles.link}`}
                                    estil='T-onboarding'
                                    text='Crea el teu compte gratuït'
                                />
                                <Boto
                                    onClick={() => tancaOnboarding()}
                                    tag='button'
                                    className={`${styles.btn_sortir} ${styles.link}`}
                                    text='Continua com a convidat'
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    };

    if (showOnboarding && !isTest && !showedToday && !isEmbedOrPopup && !isModulAvisActive) {
        return contentOnBoarding();
    } else {
        return null;
    }
}
